import { Injectable } from '@angular/core';
import { CsHttpClientService } from '@cbuild/cs-common-data-services';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { Notifications } from '../../models/notifications.model';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  constructor(private http: CsHttpClientService) {}

  public updateNotificationsRead(id: number): Observable<void> {
    return this.http.writeText<void>('api/notifications/read/update', {
      notificationId: id
    });
  }

  public updateIsNewStatus(
    notificationIdList: Array<number>
  ): Observable<void> {
    return this.http.writeText<void>('api/notifications/isNew/update', {
      notificationIds: notificationIdList
    });
  }

  public clearNotification(notificationId: number): Observable<void> {
    return this.http.read<void>(`api/notifications/clear/${notificationId}`);
  }

  public clearAllNotifications(): Observable<void> {
    return this.http.read<void>('api/notifications/clearAll');
  }

  public getNotifications(data: {
    nextRef: number | null;
    fetchRecords: number;
  }): Observable<Array<Notifications>> {
    return this.http.writeText<Array<Notifications>>(
      'api/notifications/get',
      data
    );
  }

  public getUnreadNotificationsCount(): Observable<{ count: number }> {
    return this.http
      .read<Array<{ count: number }>>('api/notifications/count')
      .pipe(map(resp => resp[0]));
  }
}
